document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{const t=document.querySelector(a.getAttribute('href'));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}}));});
// RTMC V5: add the selected membership to cart, then go straight to checkout.
document.addEventListener('submit', async function(e){
  const form=e.target.closest('.rtmc-direct-checkout'); if(!form) return;
  e.preventDefault();
  const btn=form.querySelector('button'); const old=btn.innerHTML; btn.disabled=true; btn.innerHTML='Opening secure checkout…';
  try{
    await fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}});
    const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
    if(!res.ok) throw new Error(await res.text());
    window.location.href='/checkout';
  }catch(err){console.error(err);btn.disabled=false;btn.innerHTML=old;alert('Checkout could not be started. Please refresh and try again.');}
});


/* RTMC V5.1 — Direct checkout for membership cards */
document.addEventListener('submit', async function (event) {
  const form = event.target.closest('form[data-direct-checkout="true"]');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const original = button ? button.innerHTML : '';

  try {
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = 'Opening secure checkout…';
    }

    // Keep the funnel clean: only the selected RTMC membership goes to checkout.
    await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/clear.js' : '/cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    });

    const response = await fetch(form.action, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.description || data.message || 'Could not add membership to checkout.');
    }

    window.location.assign('/checkout');
  } catch (error) {
    console.error('RTMC checkout error:', error);
    alert(error.message || 'Checkout could not be opened. Please try again.');
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.innerHTML = original;
    }
  }
});
